import React from 'react';
import UserInfo from './UserInfo';
import PaymentsInfo from './PaymentsInfo';
import PaymentPopup from './PaymentPopup';
import { PaymentData, Payment } from '../types';
import PortalHeader from './PortalHeader';
import { useLanguage } from '../i18n/LanguageProvider';

interface PaymentViewProps {
  paymentData: PaymentData;
  onPaymentClick: (payment: Payment) => void;
  showPopup: boolean;
  popupMessage: string;
  popupType: 'success' | 'cancel' | null;
}

const PaymentView: React.FC<PaymentViewProps> = ({
  paymentData,
  onPaymentClick,
  showPopup,
  popupMessage,
  popupType
}) => {
  const { t, lang } = useLanguage();

  const pdfHref =
    lang === 'hr'
      ? '/korisnicke-upute/payment-portal-hr.pdf'
      : '/korisnicke-upute/payment-portal-en.pdf';

  return (
    <div className="mx-auto w-full max-w-3xl p-4">
      <PortalHeader />
      <div className="mt-4">
        <UserInfo userData={paymentData} />
        <PaymentsInfo payments={paymentData.payments} classNumber={paymentData.classNumber} serialFormNumber={paymentData.formSerialNumber} onPaymentClick={onPaymentClick} />
        <PaymentPopup
          show={showPopup}
          message={popupMessage}
          type={popupType}
        />
         <footer className="mt-8 text-center text-sm text-gray-500">
            <ul>
                <li>
                  <a
                    href={pdfHref}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('userInstructions')}
                  </a>
                </li>
            </ul>
         </footer>
      </div>
    </div>
  );
};

export default PaymentView;